/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getAgreement } from "../graphql/queries";
import { updateAgreement } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function AgreementUpdateForm(props) {
  const {
    id: idProp,
    agreement: agreementModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    companyName: "",
    emailAddress: "",
    dateOfAgreement: "",
    officialAddress: "",
    designation: "",
    paymentDueDate: "",
    technicalName: "",
    technicalDesignation: "",
    technicalEmail: "",
    technicalPhoneNumber: "",
    billingName: "",
    billingDesignation: "",
    billingEmail: "",
    billingPhoneNumber: "",
    signingAuthorityName: "",
    commercialName: "",
    commercialDesignation: "",
    commercialEmail: "",
    commercialPhoneNumber: "",
    currency: "",
    milestones: [],
    partyA: "",
    partyB: "",
    daysOfAgreement: "",
    licensingRegion: "",
    licensingCountry: [],
    carrierType: [],
    numberOfRefreshCycles: "",
    airline: [],
    amountPaid: "",
    amountRemaining: "",
    numberOfMonthsPerCycle: "",
    contractValue: "",
    paymentStatus: "",
    paymentPlan: "",
    paymentTerm: "",
    paymentModel: "",
    paymentReceiptFilePath: "",
    agreementFilePath: "",
  };
  const [companyName, setCompanyName] = React.useState(
    initialValues.companyName
  );
  const [emailAddress, setEmailAddress] = React.useState(
    initialValues.emailAddress
  );
  const [dateOfAgreement, setDateOfAgreement] = React.useState(
    initialValues.dateOfAgreement
  );
  const [officialAddress, setOfficialAddress] = React.useState(
    initialValues.officialAddress
  );
  const [designation, setDesignation] = React.useState(
    initialValues.designation
  );
  const [paymentDueDate, setPaymentDueDate] = React.useState(
    initialValues.paymentDueDate
  );
  const [technicalName, setTechnicalName] = React.useState(
    initialValues.technicalName
  );
  const [technicalDesignation, setTechnicalDesignation] = React.useState(
    initialValues.technicalDesignation
  );
  const [technicalEmail, setTechnicalEmail] = React.useState(
    initialValues.technicalEmail
  );
  const [technicalPhoneNumber, setTechnicalPhoneNumber] = React.useState(
    initialValues.technicalPhoneNumber
  );
  const [billingName, setBillingName] = React.useState(
    initialValues.billingName
  );
  const [billingDesignation, setBillingDesignation] = React.useState(
    initialValues.billingDesignation
  );
  const [billingEmail, setBillingEmail] = React.useState(
    initialValues.billingEmail
  );
  const [billingPhoneNumber, setBillingPhoneNumber] = React.useState(
    initialValues.billingPhoneNumber
  );
  const [signingAuthorityName, setSigningAuthorityName] = React.useState(
    initialValues.signingAuthorityName
  );
  const [commercialName, setCommercialName] = React.useState(
    initialValues.commercialName
  );
  const [commercialDesignation, setCommercialDesignation] = React.useState(
    initialValues.commercialDesignation
  );
  const [commercialEmail, setCommercialEmail] = React.useState(
    initialValues.commercialEmail
  );
  const [commercialPhoneNumber, setCommercialPhoneNumber] = React.useState(
    initialValues.commercialPhoneNumber
  );
  const [currency, setCurrency] = React.useState(initialValues.currency);
  const [milestones, setMilestones] = React.useState(initialValues.milestones);
  const [partyA, setPartyA] = React.useState(initialValues.partyA);
  const [partyB, setPartyB] = React.useState(initialValues.partyB);
  const [daysOfAgreement, setDaysOfAgreement] = React.useState(
    initialValues.daysOfAgreement
  );
  const [licensingRegion, setLicensingRegion] = React.useState(
    initialValues.licensingRegion
  );
  const [licensingCountry, setLicensingCountry] = React.useState(
    initialValues.licensingCountry
  );
  const [carrierType, setCarrierType] = React.useState(
    initialValues.carrierType
  );
  const [numberOfRefreshCycles, setNumberOfRefreshCycles] = React.useState(
    initialValues.numberOfRefreshCycles
  );
  const [airline, setAirline] = React.useState(initialValues.airline);
  const [amountPaid, setAmountPaid] = React.useState(initialValues.amountPaid);
  const [amountRemaining, setAmountRemaining] = React.useState(
    initialValues.amountRemaining
  );
  const [numberOfMonthsPerCycle, setNumberOfMonthsPerCycle] = React.useState(
    initialValues.numberOfMonthsPerCycle
  );
  const [contractValue, setContractValue] = React.useState(
    initialValues.contractValue
  );
  const [paymentStatus, setPaymentStatus] = React.useState(
    initialValues.paymentStatus
  );
  const [paymentPlan, setPaymentPlan] = React.useState(
    initialValues.paymentPlan
  );
  const [paymentTerm, setPaymentTerm] = React.useState(
    initialValues.paymentTerm
  );
  const [paymentModel, setPaymentModel] = React.useState(
    initialValues.paymentModel
  );
  const [paymentReceiptFilePath, setPaymentReceiptFilePath] = React.useState(
    initialValues.paymentReceiptFilePath
  );
  const [agreementFilePath, setAgreementFilePath] = React.useState(
    initialValues.agreementFilePath
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = agreementRecord
      ? { ...initialValues, ...agreementRecord }
      : initialValues;
    setCompanyName(cleanValues.companyName);
    setEmailAddress(cleanValues.emailAddress);
    setDateOfAgreement(cleanValues.dateOfAgreement);
    setOfficialAddress(cleanValues.officialAddress);
    setDesignation(cleanValues.designation);
    setPaymentDueDate(cleanValues.paymentDueDate);
    setTechnicalName(cleanValues.technicalName);
    setTechnicalDesignation(cleanValues.technicalDesignation);
    setTechnicalEmail(cleanValues.technicalEmail);
    setTechnicalPhoneNumber(cleanValues.technicalPhoneNumber);
    setBillingName(cleanValues.billingName);
    setBillingDesignation(cleanValues.billingDesignation);
    setBillingEmail(cleanValues.billingEmail);
    setBillingPhoneNumber(cleanValues.billingPhoneNumber);
    setSigningAuthorityName(cleanValues.signingAuthorityName);
    setCommercialName(cleanValues.commercialName);
    setCommercialDesignation(cleanValues.commercialDesignation);
    setCommercialEmail(cleanValues.commercialEmail);
    setCommercialPhoneNumber(cleanValues.commercialPhoneNumber);
    setCurrency(cleanValues.currency);
    setMilestones(cleanValues.milestones ?? []);
    setCurrentMilestonesValue("");
    setPartyA(cleanValues.partyA);
    setPartyB(cleanValues.partyB);
    setDaysOfAgreement(cleanValues.daysOfAgreement);
    setLicensingRegion(cleanValues.licensingRegion);
    setLicensingCountry(cleanValues.licensingCountry ?? []);
    setCurrentLicensingCountryValue("");
    setCarrierType(cleanValues.carrierType ?? []);
    setCurrentCarrierTypeValue("");
    setNumberOfRefreshCycles(cleanValues.numberOfRefreshCycles);
    setAirline(cleanValues.airline ?? []);
    setCurrentAirlineValue("");
    setAmountPaid(cleanValues.amountPaid);
    setAmountRemaining(cleanValues.amountRemaining);
    setNumberOfMonthsPerCycle(cleanValues.numberOfMonthsPerCycle);
    setContractValue(cleanValues.contractValue);
    setPaymentStatus(cleanValues.paymentStatus);
    setPaymentPlan(cleanValues.paymentPlan);
    setPaymentTerm(cleanValues.paymentTerm);
    setPaymentModel(cleanValues.paymentModel);
    setPaymentReceiptFilePath(cleanValues.paymentReceiptFilePath);
    setAgreementFilePath(cleanValues.agreementFilePath);
    setErrors({});
  };
  const [agreementRecord, setAgreementRecord] =
    React.useState(agreementModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getAgreement.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getAgreement
        : agreementModelProp;
      setAgreementRecord(record);
    };
    queryData();
  }, [idProp, agreementModelProp]);
  React.useEffect(resetStateValues, [agreementRecord]);
  const [currentMilestonesValue, setCurrentMilestonesValue] =
    React.useState("");
  const milestonesRef = React.createRef();
  const [currentLicensingCountryValue, setCurrentLicensingCountryValue] =
    React.useState("");
  const licensingCountryRef = React.createRef();
  const [currentCarrierTypeValue, setCurrentCarrierTypeValue] =
    React.useState("");
  const carrierTypeRef = React.createRef();
  const [currentAirlineValue, setCurrentAirlineValue] = React.useState("");
  const airlineRef = React.createRef();
  const validations = {
    companyName: [],
    emailAddress: [],
    dateOfAgreement: [],
    officialAddress: [],
    designation: [],
    paymentDueDate: [],
    technicalName: [],
    technicalDesignation: [],
    technicalEmail: [],
    technicalPhoneNumber: [],
    billingName: [],
    billingDesignation: [],
    billingEmail: [],
    billingPhoneNumber: [],
    signingAuthorityName: [],
    commercialName: [],
    commercialDesignation: [],
    commercialEmail: [],
    commercialPhoneNumber: [],
    currency: [],
    milestones: [],
    partyA: [],
    partyB: [],
    daysOfAgreement: [],
    licensingRegion: [],
    licensingCountry: [],
    carrierType: [],
    numberOfRefreshCycles: [],
    airline: [],
    amountPaid: [],
    amountRemaining: [],
    numberOfMonthsPerCycle: [],
    contractValue: [],
    paymentStatus: [],
    paymentPlan: [],
    paymentTerm: [],
    paymentModel: [],
    paymentReceiptFilePath: [],
    agreementFilePath: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          companyName: companyName ?? null,
          emailAddress: emailAddress ?? null,
          dateOfAgreement: dateOfAgreement ?? null,
          officialAddress: officialAddress ?? null,
          designation: designation ?? null,
          paymentDueDate: paymentDueDate ?? null,
          technicalName: technicalName ?? null,
          technicalDesignation: technicalDesignation ?? null,
          technicalEmail: technicalEmail ?? null,
          technicalPhoneNumber: technicalPhoneNumber ?? null,
          billingName: billingName ?? null,
          billingDesignation: billingDesignation ?? null,
          billingEmail: billingEmail ?? null,
          billingPhoneNumber: billingPhoneNumber ?? null,
          signingAuthorityName: signingAuthorityName ?? null,
          commercialName: commercialName ?? null,
          commercialDesignation: commercialDesignation ?? null,
          commercialEmail: commercialEmail ?? null,
          commercialPhoneNumber: commercialPhoneNumber ?? null,
          currency: currency ?? null,
          milestones: milestones ?? null,
          partyA: partyA ?? null,
          partyB: partyB ?? null,
          daysOfAgreement: daysOfAgreement ?? null,
          licensingRegion: licensingRegion ?? null,
          licensingCountry: licensingCountry ?? null,
          carrierType: carrierType ?? null,
          numberOfRefreshCycles: numberOfRefreshCycles ?? null,
          airline: airline ?? null,
          amountPaid: amountPaid ?? null,
          amountRemaining: amountRemaining ?? null,
          numberOfMonthsPerCycle: numberOfMonthsPerCycle ?? null,
          contractValue: contractValue ?? null,
          paymentStatus: paymentStatus ?? null,
          paymentPlan: paymentPlan ?? null,
          paymentTerm: paymentTerm ?? null,
          paymentModel: paymentModel ?? null,
          paymentReceiptFilePath: paymentReceiptFilePath ?? null,
          agreementFilePath: agreementFilePath ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateAgreement.replaceAll("__typename", ""),
            variables: {
              input: {
                id: agreementRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "AgreementUpdateForm")}
      {...rest}
    >
      <TextField
        label="Company name"
        isRequired={false}
        isReadOnly={false}
        value={companyName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName: value,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.companyName ?? value;
          }
          if (errors.companyName?.hasError) {
            runValidationTasks("companyName", value);
          }
          setCompanyName(value);
        }}
        onBlur={() => runValidationTasks("companyName", companyName)}
        errorMessage={errors.companyName?.errorMessage}
        hasError={errors.companyName?.hasError}
        {...getOverrideProps(overrides, "companyName")}
      ></TextField>
      <TextField
        label="Email address"
        isRequired={false}
        isReadOnly={false}
        value={emailAddress}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress: value,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.emailAddress ?? value;
          }
          if (errors.emailAddress?.hasError) {
            runValidationTasks("emailAddress", value);
          }
          setEmailAddress(value);
        }}
        onBlur={() => runValidationTasks("emailAddress", emailAddress)}
        errorMessage={errors.emailAddress?.errorMessage}
        hasError={errors.emailAddress?.hasError}
        {...getOverrideProps(overrides, "emailAddress")}
      ></TextField>
      <TextField
        label="Date of agreement"
        isRequired={false}
        isReadOnly={false}
        value={dateOfAgreement}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement: value,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.dateOfAgreement ?? value;
          }
          if (errors.dateOfAgreement?.hasError) {
            runValidationTasks("dateOfAgreement", value);
          }
          setDateOfAgreement(value);
        }}
        onBlur={() => runValidationTasks("dateOfAgreement", dateOfAgreement)}
        errorMessage={errors.dateOfAgreement?.errorMessage}
        hasError={errors.dateOfAgreement?.hasError}
        {...getOverrideProps(overrides, "dateOfAgreement")}
      ></TextField>
      <TextField
        label="Official address"
        isRequired={false}
        isReadOnly={false}
        value={officialAddress}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress: value,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.officialAddress ?? value;
          }
          if (errors.officialAddress?.hasError) {
            runValidationTasks("officialAddress", value);
          }
          setOfficialAddress(value);
        }}
        onBlur={() => runValidationTasks("officialAddress", officialAddress)}
        errorMessage={errors.officialAddress?.errorMessage}
        hasError={errors.officialAddress?.hasError}
        {...getOverrideProps(overrides, "officialAddress")}
      ></TextField>
      <TextField
        label="Designation"
        isRequired={false}
        isReadOnly={false}
        value={designation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation: value,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.designation ?? value;
          }
          if (errors.designation?.hasError) {
            runValidationTasks("designation", value);
          }
          setDesignation(value);
        }}
        onBlur={() => runValidationTasks("designation", designation)}
        errorMessage={errors.designation?.errorMessage}
        hasError={errors.designation?.hasError}
        {...getOverrideProps(overrides, "designation")}
      ></TextField>
      <TextField
        label="Payment due date"
        isRequired={false}
        isReadOnly={false}
        value={paymentDueDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate: value,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentDueDate ?? value;
          }
          if (errors.paymentDueDate?.hasError) {
            runValidationTasks("paymentDueDate", value);
          }
          setPaymentDueDate(value);
        }}
        onBlur={() => runValidationTasks("paymentDueDate", paymentDueDate)}
        errorMessage={errors.paymentDueDate?.errorMessage}
        hasError={errors.paymentDueDate?.hasError}
        {...getOverrideProps(overrides, "paymentDueDate")}
      ></TextField>
      <TextField
        label="Technical name"
        isRequired={false}
        isReadOnly={false}
        value={technicalName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName: value,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.technicalName ?? value;
          }
          if (errors.technicalName?.hasError) {
            runValidationTasks("technicalName", value);
          }
          setTechnicalName(value);
        }}
        onBlur={() => runValidationTasks("technicalName", technicalName)}
        errorMessage={errors.technicalName?.errorMessage}
        hasError={errors.technicalName?.hasError}
        {...getOverrideProps(overrides, "technicalName")}
      ></TextField>
      <TextField
        label="Technical designation"
        isRequired={false}
        isReadOnly={false}
        value={technicalDesignation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation: value,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.technicalDesignation ?? value;
          }
          if (errors.technicalDesignation?.hasError) {
            runValidationTasks("technicalDesignation", value);
          }
          setTechnicalDesignation(value);
        }}
        onBlur={() =>
          runValidationTasks("technicalDesignation", technicalDesignation)
        }
        errorMessage={errors.technicalDesignation?.errorMessage}
        hasError={errors.technicalDesignation?.hasError}
        {...getOverrideProps(overrides, "technicalDesignation")}
      ></TextField>
      <TextField
        label="Technical email"
        isRequired={false}
        isReadOnly={false}
        value={technicalEmail}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail: value,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.technicalEmail ?? value;
          }
          if (errors.technicalEmail?.hasError) {
            runValidationTasks("technicalEmail", value);
          }
          setTechnicalEmail(value);
        }}
        onBlur={() => runValidationTasks("technicalEmail", technicalEmail)}
        errorMessage={errors.technicalEmail?.errorMessage}
        hasError={errors.technicalEmail?.hasError}
        {...getOverrideProps(overrides, "technicalEmail")}
      ></TextField>
      <TextField
        label="Technical phone number"
        isRequired={false}
        isReadOnly={false}
        value={technicalPhoneNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber: value,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.technicalPhoneNumber ?? value;
          }
          if (errors.technicalPhoneNumber?.hasError) {
            runValidationTasks("technicalPhoneNumber", value);
          }
          setTechnicalPhoneNumber(value);
        }}
        onBlur={() =>
          runValidationTasks("technicalPhoneNumber", technicalPhoneNumber)
        }
        errorMessage={errors.technicalPhoneNumber?.errorMessage}
        hasError={errors.technicalPhoneNumber?.hasError}
        {...getOverrideProps(overrides, "technicalPhoneNumber")}
      ></TextField>
      <TextField
        label="Billing name"
        isRequired={false}
        isReadOnly={false}
        value={billingName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName: value,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.billingName ?? value;
          }
          if (errors.billingName?.hasError) {
            runValidationTasks("billingName", value);
          }
          setBillingName(value);
        }}
        onBlur={() => runValidationTasks("billingName", billingName)}
        errorMessage={errors.billingName?.errorMessage}
        hasError={errors.billingName?.hasError}
        {...getOverrideProps(overrides, "billingName")}
      ></TextField>
      <TextField
        label="Billing designation"
        isRequired={false}
        isReadOnly={false}
        value={billingDesignation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation: value,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.billingDesignation ?? value;
          }
          if (errors.billingDesignation?.hasError) {
            runValidationTasks("billingDesignation", value);
          }
          setBillingDesignation(value);
        }}
        onBlur={() =>
          runValidationTasks("billingDesignation", billingDesignation)
        }
        errorMessage={errors.billingDesignation?.errorMessage}
        hasError={errors.billingDesignation?.hasError}
        {...getOverrideProps(overrides, "billingDesignation")}
      ></TextField>
      <TextField
        label="Billing email"
        isRequired={false}
        isReadOnly={false}
        value={billingEmail}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail: value,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.billingEmail ?? value;
          }
          if (errors.billingEmail?.hasError) {
            runValidationTasks("billingEmail", value);
          }
          setBillingEmail(value);
        }}
        onBlur={() => runValidationTasks("billingEmail", billingEmail)}
        errorMessage={errors.billingEmail?.errorMessage}
        hasError={errors.billingEmail?.hasError}
        {...getOverrideProps(overrides, "billingEmail")}
      ></TextField>
      <TextField
        label="Billing phone number"
        isRequired={false}
        isReadOnly={false}
        value={billingPhoneNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber: value,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.billingPhoneNumber ?? value;
          }
          if (errors.billingPhoneNumber?.hasError) {
            runValidationTasks("billingPhoneNumber", value);
          }
          setBillingPhoneNumber(value);
        }}
        onBlur={() =>
          runValidationTasks("billingPhoneNumber", billingPhoneNumber)
        }
        errorMessage={errors.billingPhoneNumber?.errorMessage}
        hasError={errors.billingPhoneNumber?.hasError}
        {...getOverrideProps(overrides, "billingPhoneNumber")}
      ></TextField>
      <TextField
        label="Signing authority name"
        isRequired={false}
        isReadOnly={false}
        value={signingAuthorityName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName: value,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.signingAuthorityName ?? value;
          }
          if (errors.signingAuthorityName?.hasError) {
            runValidationTasks("signingAuthorityName", value);
          }
          setSigningAuthorityName(value);
        }}
        onBlur={() =>
          runValidationTasks("signingAuthorityName", signingAuthorityName)
        }
        errorMessage={errors.signingAuthorityName?.errorMessage}
        hasError={errors.signingAuthorityName?.hasError}
        {...getOverrideProps(overrides, "signingAuthorityName")}
      ></TextField>
      <TextField
        label="Commercial name"
        isRequired={false}
        isReadOnly={false}
        value={commercialName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName: value,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.commercialName ?? value;
          }
          if (errors.commercialName?.hasError) {
            runValidationTasks("commercialName", value);
          }
          setCommercialName(value);
        }}
        onBlur={() => runValidationTasks("commercialName", commercialName)}
        errorMessage={errors.commercialName?.errorMessage}
        hasError={errors.commercialName?.hasError}
        {...getOverrideProps(overrides, "commercialName")}
      ></TextField>
      <TextField
        label="Commercial designation"
        isRequired={false}
        isReadOnly={false}
        value={commercialDesignation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation: value,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.commercialDesignation ?? value;
          }
          if (errors.commercialDesignation?.hasError) {
            runValidationTasks("commercialDesignation", value);
          }
          setCommercialDesignation(value);
        }}
        onBlur={() =>
          runValidationTasks("commercialDesignation", commercialDesignation)
        }
        errorMessage={errors.commercialDesignation?.errorMessage}
        hasError={errors.commercialDesignation?.hasError}
        {...getOverrideProps(overrides, "commercialDesignation")}
      ></TextField>
      <TextField
        label="Commercial email"
        isRequired={false}
        isReadOnly={false}
        value={commercialEmail}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail: value,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.commercialEmail ?? value;
          }
          if (errors.commercialEmail?.hasError) {
            runValidationTasks("commercialEmail", value);
          }
          setCommercialEmail(value);
        }}
        onBlur={() => runValidationTasks("commercialEmail", commercialEmail)}
        errorMessage={errors.commercialEmail?.errorMessage}
        hasError={errors.commercialEmail?.hasError}
        {...getOverrideProps(overrides, "commercialEmail")}
      ></TextField>
      <TextField
        label="Commercial phone number"
        isRequired={false}
        isReadOnly={false}
        value={commercialPhoneNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber: value,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.commercialPhoneNumber ?? value;
          }
          if (errors.commercialPhoneNumber?.hasError) {
            runValidationTasks("commercialPhoneNumber", value);
          }
          setCommercialPhoneNumber(value);
        }}
        onBlur={() =>
          runValidationTasks("commercialPhoneNumber", commercialPhoneNumber)
        }
        errorMessage={errors.commercialPhoneNumber?.errorMessage}
        hasError={errors.commercialPhoneNumber?.hasError}
        {...getOverrideProps(overrides, "commercialPhoneNumber")}
      ></TextField>
      <TextField
        label="Currency"
        isRequired={false}
        isReadOnly={false}
        value={currency}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency: value,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.currency ?? value;
          }
          if (errors.currency?.hasError) {
            runValidationTasks("currency", value);
          }
          setCurrency(value);
        }}
        onBlur={() => runValidationTasks("currency", currency)}
        errorMessage={errors.currency?.errorMessage}
        hasError={errors.currency?.hasError}
        {...getOverrideProps(overrides, "currency")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones: values,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            values = result?.milestones ?? values;
          }
          setMilestones(values);
          setCurrentMilestonesValue("");
        }}
        currentFieldValue={currentMilestonesValue}
        label={"Milestones"}
        items={milestones}
        hasError={errors?.milestones?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("milestones", currentMilestonesValue)
        }
        errorMessage={errors?.milestones?.errorMessage}
        setFieldValue={setCurrentMilestonesValue}
        inputFieldRef={milestonesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Milestones"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={currentMilestonesValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (errors.milestones?.hasError) {
              runValidationTasks("milestones", value);
            }
            setCurrentMilestonesValue(value);
          }}
          onBlur={() =>
            runValidationTasks("milestones", currentMilestonesValue)
          }
          errorMessage={errors.milestones?.errorMessage}
          hasError={errors.milestones?.hasError}
          ref={milestonesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "milestones")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Party a"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={partyA}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA: value,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.partyA ?? value;
          }
          if (errors.partyA?.hasError) {
            runValidationTasks("partyA", value);
          }
          setPartyA(value);
        }}
        onBlur={() => runValidationTasks("partyA", partyA)}
        errorMessage={errors.partyA?.errorMessage}
        hasError={errors.partyA?.hasError}
        {...getOverrideProps(overrides, "partyA")}
      ></TextField>
      <TextField
        label="Party b"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={partyB}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB: value,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.partyB ?? value;
          }
          if (errors.partyB?.hasError) {
            runValidationTasks("partyB", value);
          }
          setPartyB(value);
        }}
        onBlur={() => runValidationTasks("partyB", partyB)}
        errorMessage={errors.partyB?.errorMessage}
        hasError={errors.partyB?.hasError}
        {...getOverrideProps(overrides, "partyB")}
      ></TextField>
      <TextField
        label="Days of agreement"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={daysOfAgreement}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement: value,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.daysOfAgreement ?? value;
          }
          if (errors.daysOfAgreement?.hasError) {
            runValidationTasks("daysOfAgreement", value);
          }
          setDaysOfAgreement(value);
        }}
        onBlur={() => runValidationTasks("daysOfAgreement", daysOfAgreement)}
        errorMessage={errors.daysOfAgreement?.errorMessage}
        hasError={errors.daysOfAgreement?.hasError}
        {...getOverrideProps(overrides, "daysOfAgreement")}
      ></TextField>
      <TextField
        label="Licensing region"
        isRequired={false}
        isReadOnly={false}
        value={licensingRegion}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion: value,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.licensingRegion ?? value;
          }
          if (errors.licensingRegion?.hasError) {
            runValidationTasks("licensingRegion", value);
          }
          setLicensingRegion(value);
        }}
        onBlur={() => runValidationTasks("licensingRegion", licensingRegion)}
        errorMessage={errors.licensingRegion?.errorMessage}
        hasError={errors.licensingRegion?.hasError}
        {...getOverrideProps(overrides, "licensingRegion")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry: values,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            values = result?.licensingCountry ?? values;
          }
          setLicensingCountry(values);
          setCurrentLicensingCountryValue("");
        }}
        currentFieldValue={currentLicensingCountryValue}
        label={"Licensing country"}
        items={licensingCountry}
        hasError={errors?.licensingCountry?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "licensingCountry",
            currentLicensingCountryValue
          )
        }
        errorMessage={errors?.licensingCountry?.errorMessage}
        setFieldValue={setCurrentLicensingCountryValue}
        inputFieldRef={licensingCountryRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Licensing country"
          isRequired={false}
          isReadOnly={false}
          value={currentLicensingCountryValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.licensingCountry?.hasError) {
              runValidationTasks("licensingCountry", value);
            }
            setCurrentLicensingCountryValue(value);
          }}
          onBlur={() =>
            runValidationTasks("licensingCountry", currentLicensingCountryValue)
          }
          errorMessage={errors.licensingCountry?.errorMessage}
          hasError={errors.licensingCountry?.hasError}
          ref={licensingCountryRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "licensingCountry")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType: values,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            values = result?.carrierType ?? values;
          }
          setCarrierType(values);
          setCurrentCarrierTypeValue("");
        }}
        currentFieldValue={currentCarrierTypeValue}
        label={"Carrier type"}
        items={carrierType}
        hasError={errors?.carrierType?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("carrierType", currentCarrierTypeValue)
        }
        errorMessage={errors?.carrierType?.errorMessage}
        setFieldValue={setCurrentCarrierTypeValue}
        inputFieldRef={carrierTypeRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Carrier type"
          isRequired={false}
          isReadOnly={false}
          value={currentCarrierTypeValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.carrierType?.hasError) {
              runValidationTasks("carrierType", value);
            }
            setCurrentCarrierTypeValue(value);
          }}
          onBlur={() =>
            runValidationTasks("carrierType", currentCarrierTypeValue)
          }
          errorMessage={errors.carrierType?.errorMessage}
          hasError={errors.carrierType?.hasError}
          ref={carrierTypeRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "carrierType")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Number of refresh cycles"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={numberOfRefreshCycles}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles: value,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.numberOfRefreshCycles ?? value;
          }
          if (errors.numberOfRefreshCycles?.hasError) {
            runValidationTasks("numberOfRefreshCycles", value);
          }
          setNumberOfRefreshCycles(value);
        }}
        onBlur={() =>
          runValidationTasks("numberOfRefreshCycles", numberOfRefreshCycles)
        }
        errorMessage={errors.numberOfRefreshCycles?.errorMessage}
        hasError={errors.numberOfRefreshCycles?.hasError}
        {...getOverrideProps(overrides, "numberOfRefreshCycles")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline: values,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            values = result?.airline ?? values;
          }
          setAirline(values);
          setCurrentAirlineValue("");
        }}
        currentFieldValue={currentAirlineValue}
        label={"Airline"}
        items={airline}
        hasError={errors?.airline?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("airline", currentAirlineValue)
        }
        errorMessage={errors?.airline?.errorMessage}
        setFieldValue={setCurrentAirlineValue}
        inputFieldRef={airlineRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Airline"
          isRequired={false}
          isReadOnly={false}
          value={currentAirlineValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.airline?.hasError) {
              runValidationTasks("airline", value);
            }
            setCurrentAirlineValue(value);
          }}
          onBlur={() => runValidationTasks("airline", currentAirlineValue)}
          errorMessage={errors.airline?.errorMessage}
          hasError={errors.airline?.hasError}
          ref={airlineRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "airline")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Amount paid"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={amountPaid}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid: value,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.amountPaid ?? value;
          }
          if (errors.amountPaid?.hasError) {
            runValidationTasks("amountPaid", value);
          }
          setAmountPaid(value);
        }}
        onBlur={() => runValidationTasks("amountPaid", amountPaid)}
        errorMessage={errors.amountPaid?.errorMessage}
        hasError={errors.amountPaid?.hasError}
        {...getOverrideProps(overrides, "amountPaid")}
      ></TextField>
      <TextField
        label="Amount remaining"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={amountRemaining}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining: value,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.amountRemaining ?? value;
          }
          if (errors.amountRemaining?.hasError) {
            runValidationTasks("amountRemaining", value);
          }
          setAmountRemaining(value);
        }}
        onBlur={() => runValidationTasks("amountRemaining", amountRemaining)}
        errorMessage={errors.amountRemaining?.errorMessage}
        hasError={errors.amountRemaining?.hasError}
        {...getOverrideProps(overrides, "amountRemaining")}
      ></TextField>
      <TextField
        label="Number of months per cycle"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={numberOfMonthsPerCycle}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle: value,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.numberOfMonthsPerCycle ?? value;
          }
          if (errors.numberOfMonthsPerCycle?.hasError) {
            runValidationTasks("numberOfMonthsPerCycle", value);
          }
          setNumberOfMonthsPerCycle(value);
        }}
        onBlur={() =>
          runValidationTasks("numberOfMonthsPerCycle", numberOfMonthsPerCycle)
        }
        errorMessage={errors.numberOfMonthsPerCycle?.errorMessage}
        hasError={errors.numberOfMonthsPerCycle?.hasError}
        {...getOverrideProps(overrides, "numberOfMonthsPerCycle")}
      ></TextField>
      <TextField
        label="Contract value"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={contractValue}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue: value,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.contractValue ?? value;
          }
          if (errors.contractValue?.hasError) {
            runValidationTasks("contractValue", value);
          }
          setContractValue(value);
        }}
        onBlur={() => runValidationTasks("contractValue", contractValue)}
        errorMessage={errors.contractValue?.errorMessage}
        hasError={errors.contractValue?.hasError}
        {...getOverrideProps(overrides, "contractValue")}
      ></TextField>
      <SelectField
        label="Payment status"
        placeholder="Please select an option"
        isDisabled={false}
        value={paymentStatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus: value,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentStatus ?? value;
          }
          if (errors.paymentStatus?.hasError) {
            runValidationTasks("paymentStatus", value);
          }
          setPaymentStatus(value);
        }}
        onBlur={() => runValidationTasks("paymentStatus", paymentStatus)}
        errorMessage={errors.paymentStatus?.errorMessage}
        hasError={errors.paymentStatus?.hasError}
        {...getOverrideProps(overrides, "paymentStatus")}
      >
        <option
          children="Paid"
          value="Paid"
          {...getOverrideProps(overrides, "paymentStatusoption0")}
        ></option>
        <option
          children="Un paid"
          value="UnPaid"
          {...getOverrideProps(overrides, "paymentStatusoption1")}
        ></option>
        <option
          children="Partially paid"
          value="PartiallyPaid"
          {...getOverrideProps(overrides, "paymentStatusoption2")}
        ></option>
        <option
          children="In process"
          value="InProcess"
          {...getOverrideProps(overrides, "paymentStatusoption3")}
        ></option>
      </SelectField>
      <SelectField
        label="Payment plan"
        placeholder="Please select an option"
        isDisabled={false}
        value={paymentPlan}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan: value,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentPlan ?? value;
          }
          if (errors.paymentPlan?.hasError) {
            runValidationTasks("paymentPlan", value);
          }
          setPaymentPlan(value);
        }}
        onBlur={() => runValidationTasks("paymentPlan", paymentPlan)}
        errorMessage={errors.paymentPlan?.errorMessage}
        hasError={errors.paymentPlan?.hasError}
        {...getOverrideProps(overrides, "paymentPlan")}
      >
        <option
          children="Monthly"
          value="Monthly"
          {...getOverrideProps(overrides, "paymentPlanoption0")}
        ></option>
        <option
          children="Quarterly"
          value="Quarterly"
          {...getOverrideProps(overrides, "paymentPlanoption1")}
        ></option>
        <option
          children="Bi annual"
          value="BiAnnual"
          {...getOverrideProps(overrides, "paymentPlanoption2")}
        ></option>
        <option
          children="Annual"
          value="Annual"
          {...getOverrideProps(overrides, "paymentPlanoption3")}
        ></option>
        <option
          children="Pay and earn"
          value="PayAndEarn"
          {...getOverrideProps(overrides, "paymentPlanoption4")}
        ></option>
        <option
          children="Milestone wise"
          value="MilestoneWise"
          {...getOverrideProps(overrides, "paymentPlanoption5")}
        ></option>
      </SelectField>
      <SelectField
        label="Payment term"
        placeholder="Please select an option"
        isDisabled={false}
        value={paymentTerm}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm: value,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentTerm ?? value;
          }
          if (errors.paymentTerm?.hasError) {
            runValidationTasks("paymentTerm", value);
          }
          setPaymentTerm(value);
        }}
        onBlur={() => runValidationTasks("paymentTerm", paymentTerm)}
        errorMessage={errors.paymentTerm?.errorMessage}
        hasError={errors.paymentTerm?.hasError}
        {...getOverrideProps(overrides, "paymentTerm")}
      >
        <option
          children="In advance"
          value="InAdvance"
          {...getOverrideProps(overrides, "paymentTermoption0")}
        ></option>
        <option
          children="In arrears"
          value="InArrears"
          {...getOverrideProps(overrides, "paymentTermoption1")}
        ></option>
      </SelectField>
      <SelectField
        label="Payment model"
        placeholder="Please select an option"
        isDisabled={false}
        value={paymentModel}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel: value,
              paymentReceiptFilePath,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentModel ?? value;
          }
          if (errors.paymentModel?.hasError) {
            runValidationTasks("paymentModel", value);
          }
          setPaymentModel(value);
        }}
        onBlur={() => runValidationTasks("paymentModel", paymentModel)}
        errorMessage={errors.paymentModel?.errorMessage}
        hasError={errors.paymentModel?.hasError}
        {...getOverrideProps(overrides, "paymentModel")}
      >
        <option
          children="Subscription model"
          value="SubscriptionModel"
          {...getOverrideProps(overrides, "paymentModeloption0")}
        ></option>
        <option
          children="Milestone model"
          value="MilestoneModel"
          {...getOverrideProps(overrides, "paymentModeloption1")}
        ></option>
        <option
          children="Revenue share"
          value="RevenueShare"
          {...getOverrideProps(overrides, "paymentModeloption2")}
        ></option>
      </SelectField>
      <TextField
        label="Payment receipt file path"
        isRequired={false}
        isReadOnly={false}
        value={paymentReceiptFilePath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath: value,
              agreementFilePath,
            };
            const result = onChange(modelFields);
            value = result?.paymentReceiptFilePath ?? value;
          }
          if (errors.paymentReceiptFilePath?.hasError) {
            runValidationTasks("paymentReceiptFilePath", value);
          }
          setPaymentReceiptFilePath(value);
        }}
        onBlur={() =>
          runValidationTasks("paymentReceiptFilePath", paymentReceiptFilePath)
        }
        errorMessage={errors.paymentReceiptFilePath?.errorMessage}
        hasError={errors.paymentReceiptFilePath?.hasError}
        {...getOverrideProps(overrides, "paymentReceiptFilePath")}
      ></TextField>
      <TextField
        label="Agreement file path"
        isRequired={false}
        isReadOnly={false}
        value={agreementFilePath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companyName,
              emailAddress,
              dateOfAgreement,
              officialAddress,
              designation,
              paymentDueDate,
              technicalName,
              technicalDesignation,
              technicalEmail,
              technicalPhoneNumber,
              billingName,
              billingDesignation,
              billingEmail,
              billingPhoneNumber,
              signingAuthorityName,
              commercialName,
              commercialDesignation,
              commercialEmail,
              commercialPhoneNumber,
              currency,
              milestones,
              partyA,
              partyB,
              daysOfAgreement,
              licensingRegion,
              licensingCountry,
              carrierType,
              numberOfRefreshCycles,
              airline,
              amountPaid,
              amountRemaining,
              numberOfMonthsPerCycle,
              contractValue,
              paymentStatus,
              paymentPlan,
              paymentTerm,
              paymentModel,
              paymentReceiptFilePath,
              agreementFilePath: value,
            };
            const result = onChange(modelFields);
            value = result?.agreementFilePath ?? value;
          }
          if (errors.agreementFilePath?.hasError) {
            runValidationTasks("agreementFilePath", value);
          }
          setAgreementFilePath(value);
        }}
        onBlur={() =>
          runValidationTasks("agreementFilePath", agreementFilePath)
        }
        errorMessage={errors.agreementFilePath?.errorMessage}
        hasError={errors.agreementFilePath?.hasError}
        {...getOverrideProps(overrides, "agreementFilePath")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || agreementModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || agreementModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
